import styled, { sProp, PrimaryHighlight } from '../../../theme/styled'
import { styledComponentWithProps } from '../../Styled/Shared'

const elementProp = sProp(['projectTree', 'elements'])
const fontsProp = sProp(['fonts'])

export const CalcBar = styled.div`
  flex: 1 0 auto;
  min-height: 0;
  height: 200px;

  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 14px;
    font-size: ${fontsProp('fontSize')};
    font-weight: bold;
  }
`

type ItemLineProps = {
  active?: boolean
}

export const ItemLine = styledComponentWithProps<ItemLineProps>(styled.button)`
  color: ${elementProp('elementButtonColor')};
  background: ${elementProp('elementButtonBackground')};

  text-align: left;

  display: block;
  border: ${props =>
    props.active
      ? props.theme.projectTree.elements.activeButtonBorder
      : props.theme.projectTree.elements.inactiveButtonBorder};
  border-radius: 0;
  width: 100%;

  padding: 7px 25px;
  line-height: 16px;
  margin-bottom: 15px;

  font-size: ${elementProp('fontSize')};

  cursor: pointer;

  &::first-letter {
    text-transform: uppercase;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export const CaseList = styled.ul`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  li {
    /* TODO-theme */
    border-bottom: 1px solid #7c878e;
    padding: 0;
  }

  li.active {
    flex: 1 0 auto;
    border-left: 8px solid ${PrimaryHighlight};
    padding-right: 20px;
    padding-left: 12px;
    padding-bottom: 12px;
  }
`

export const AddCaseBlock = styled.div`
  border-top: 1px solid ${fontsProp('inactiveTextColor')};
  position: absolute;
  width: 100%;
  height: 61px;
  padding: 15px;
  bottom: 0;
  font-weight: bold;
  color: ${fontsProp('textColor')};
  background: white;

  button {
    display: block;
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: ${elementProp('fontSize')};
  }
`

export const CaseButton = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;

  height: 32px;
  width: 100%;

  button {
    display: flex;

    flex-direction: row;
    justify-content: left;
    align-items: center;

    border: 0;
    border-radius: 0;
    cursor: pointer;

    font-size: ${elementProp('fontSize')};
    font-weight: inherit;
    letter-spacing: 0.4px;

    color: ${fontsProp('textColor')};
    background: none;
  }

  button.main {
    flex: 1;
  }

  img {
    width: 10px;
    height: 10px;
    margin-right: 10px;
  }

  .case-button-label {
    width: 100%;
    text-align: left;
  }

  .hover-right-action {
    width: 0px;
    float: right;
    padding: 1px;
    margin-right: -6px;
    display: none;
  }

  &.single img {
    opacity: 0.5;
  }

  &.open {
    font-weight: bold;
    height: 39px;
    padding: 9px 6px;

    img {
      transform: rotate(90deg);
    }
  }

  &.closed {
    padding: 9px 26px;
  }

  &:hover {
    background: #eef1f2;
    .hover-right-action {
      width: 20px;
      display: inline-flex;
    }
  }

  &.open:hover {
    background: inherit;
    cursor: default;
  }
`

export const AddLoadButton = styled.button`
  border: 0;
  font-weight: bold;
  font-size: 20px;
  color: ${fontsProp('textColor')};
  background: none;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/InputCategoryStyles.tsx